export const GTM_TIKTOK_TAG_LEAK_PATTERN =
  /^TT-[A-Z0-9]+-Web-Tag-Pixel_Setup$/i;

const TIKTOK_PIXEL_ID_PATTERN = /^TT-[A-Z0-9]+$/i;

export const sanitizeTiktokPixelId = (rawId: string): string | null => {
  const trimmed = rawId?.trim();
  if (!trimmed) {
    return null;
  }

  const withoutGtmSuffix = trimmed.replace(/-Web-Tag-Pixel_Setup$/i, "");

  if (!TIKTOK_PIXEL_ID_PATTERN.test(withoutGtmSuffix)) {
    return null;
  }

  return withoutGtmSuffix;
};

export const removeLeakedGtmTikTokTagText = (): void => {
  if (typeof document === "undefined") {
    return;
  }

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);

  const nodesToRemove: Node[] = [];
  let node = walker.nextNode();

  while (node) {
    const text = node.textContent?.trim();
    if (text && GTM_TIKTOK_TAG_LEAK_PATTERN.test(text)) {
      nodesToRemove.push(node.parentElement ?? node);
    }
    node = walker.nextNode();
  }

  nodesToRemove.forEach((el) => {
    el.parentNode?.removeChild(el);
  });
};
